/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  CreateConditionalOrderOptions,
  CreateConditionalOrderStatus201,
  CreateConditionalOrderStatus400,
  CreateConditionalOrderStatus401,
  CreateConditionalOrderStatus500,
} from '../types/CreateConditionalOrder'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { createConditionalOrder } from '../clients/createConditionalOrder'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const createConditionalOrderMutationKey = () => [{ url: '/v1/orders/conditional' }] as const

export function createConditionalOrderMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = createConditionalOrderMutationKey()
  return mutationOptions<
    CreateConditionalOrderStatus201,
    ResponseErrorConfig<
      | CreateConditionalOrderStatus400
      | CreateConditionalOrderStatus401
      | CreateConditionalOrderStatus500
    >,
    CreateConditionalOrderOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return createConditionalOrder({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Create a new conditional orders
 * {@link /v1/orders/conditional}
 */
export function useCreateConditionalOrder<TContext>(
  options: {
    mutation?: UseMutationOptions<
      CreateConditionalOrderStatus201,
      ResponseErrorConfig<
        | CreateConditionalOrderStatus400
        | CreateConditionalOrderStatus401
        | CreateConditionalOrderStatus500
      >,
      CreateConditionalOrderOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? createConditionalOrderMutationKey()

  const baseOptions = createConditionalOrderMutationOptions(config) as UseMutationOptions<
    CreateConditionalOrderStatus201,
    ResponseErrorConfig<
      | CreateConditionalOrderStatus400
      | CreateConditionalOrderStatus401
      | CreateConditionalOrderStatus500
    >,
    CreateConditionalOrderOptions,
    TContext
  >

  return useMutation<
    CreateConditionalOrderStatus201,
    ResponseErrorConfig<
      | CreateConditionalOrderStatus400
      | CreateConditionalOrderStatus401
      | CreateConditionalOrderStatus500
    >,
    CreateConditionalOrderOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    CreateConditionalOrderStatus201,
    ResponseErrorConfig<
      | CreateConditionalOrderStatus400
      | CreateConditionalOrderStatus401
      | CreateConditionalOrderStatus500
    >,
    CreateConditionalOrderOptions,
    TContext
  >
}
